// Centralized CMP dashboard display formatters (defect ledger SH-004/SH-009).
// Display dates across manage tables and detail pages use the long form
// "January 01, 2026". Do not re-declare per-page Intl formatters — import
// these instead so the whole dashboard stays consistent.

export const cmpLongDateFormatter = new Intl.DateTimeFormat("en-CA", {
  month: "long",
  day: "2-digit",
  year: "numeric",
});

// Renewal dates and other calendar-only values are stored as UTC instants,
// but their day is the business value. Always render those values in UTC so
// midnight UTC does not become the prior day in negative-offset timezones.
// True timestamps (for example, "last updated") must continue using the
// regular local-time formatters above and below.
export const cmpLongUtcCalendarDateFormatter = new Intl.DateTimeFormat(
  "en-CA",
  {
    month: "long",
    day: "2-digit",
    year: "numeric",
    timeZone: "UTC",
  }
);

export const cmpLongDateTimeFormatter = new Intl.DateTimeFormat("en-CA", {
  month: "long",
  day: "2-digit",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
});

export const cmpTimeFormatter = new Intl.DateTimeFormat("en-CA", {
  hour: "numeric",
  minute: "2-digit",
});

export const formatLongDate = (value: number | Date): string =>
  cmpLongDateFormatter.format(value instanceof Date ? value : new Date(value));

export const formatUtcCalendarDate = (
  value?: number | Date | null
): string => {
  if (value === undefined || value === null) {
    return "-";
  }

  return cmpLongUtcCalendarDateFormatter.format(
    value instanceof Date ? value : new Date(value)
  );
};

export const getUtcCalendarDateStartUtcMilli = (dateInput: string): number =>
  new Date(`${dateInput}T00:00:00.000Z`).getTime();

export const getUtcCalendarDateEndUtcMilli = (dateInput: string): number =>
  new Date(`${dateInput}T23:59:59.999Z`).getTime();

export const cmpCurrencyFormatter = new Intl.NumberFormat("en-CA", {
  currency: "CAD",
  style: "currency",
});

export const formatCurrencyFromCents = (amountInCents?: number | null): string =>
  cmpCurrencyFormatter.format((amountInCents || 0) / 100);

export const formatCurrencyFromDollars = (amountInDollars?: number | null): string =>
  cmpCurrencyFormatter.format(amountInDollars || 0);
